export const SESSION_STORAGE_KEY = 'mk_profile_gloss';
export const SESSION_STORAGE_KEY_LANG = 'mk_profile_gloss_lang';
export const PERSISTED_DATA_KEY = 'mk_profile_persisted_data';

export const SEARCH_MIN_LENGTH = 3;
export const SEARCH_MAX_LENGTH = 24;
export const SEARCH_MAX_ITEMS_COUNT = 50;
export const SEARCH_LIMIT = 10;
export const DEBOUNCE_DELAY = 500;

export enum ERROR_CODES {
  CONFLICT = 409,
}

export const VORTEX_ACCOUNTS = '/api/accounts';
export const VORTEX_AUTOCOMPLETE = '/api/accounts/search/autocomplete/';
export const VORTEX_SEARCH = '/api/accounts/search/';
export const GLOSS = '/api/graphql/glossary/';

export enum ROUTES {
  ROOT = '/',
  PROFILE_ACCESS_CODE = '/statistics/:id/ac/:access_code/',
  PROFILE = '/statistics/:id/:battletype?/:season?',
  ACHIEVEMENTS = '/achievements/:id/:sortorder?',
}

export enum FETCHING_KEYS {
  ACCOUNT = 'account',
  CLAN = 'clan',
  STATISTICS = 'statistics',
}

// @ts-ignore
export const SEASONAL_BATTLE_TYPES = ['rank', 'rating'];

export const PVP_BATTLE_TYPES = ['pvp', 'pvp_solo', 'pvp_div2', 'pvp_div3'];

export const RANK_BATTLE_TYPES = ['rank_solo', 'rank_div2', 'rank_div3'];

export const RATING_BATTLE_TYPES = ['rating_solo', 'rating_div'];

export const RANK_OLD_BATTLE_TYPES = ['rank_old_solo', 'rank_old_div2', 'rank_old_div3'];

export const DIVISIONAL_BATTLE_TYPES = ['pvp', 'rank', 'rank_old', 'rating'];

export const STAT_BATTLE_TYPES: StatBattleType[] = [
  'pve',
  'pvp',
  'pvp_div2',
  'pvp_div3',
  'rank_solo',
  'rank_div2',
  'rank_div3',
  'rank_old_solo',
  'rank_old_div2',
  'rank_old_div3',
  'rating_solo',
  'rating_div',
  'club',
  'clan',
];

export const BATTLE_TYPES: BattleTypeList = [
  {
    id: 'pvp',
    selector: 'pvp',
  },
  {
    id: 'rank',
    selector: 'rank',
  },
  {
    id: 'rank_old',
    selector: 'rank',
  },
  {
    id: 'pve',
    selector: 'pve',
  },
  {
    id: 'rating',
    selector: 'rating',
  },
];

export const ACHIEVEMENT_SORT_ORDER: AchievementsSortOrderList = [
  {
    id: 'default',
    selector: 'default',
  },
  {
    id: 'date',
    selector: 'date',
  },
  {
    id: 'count',
    selector: 'count',
  },
];

export enum ACHIEVEMENT_GROUP_TYPES {
  BATTLE_TYPE = 'battle',
  NOT_USED = 'not_used',
}

export enum ACHIEVEMENT_SUBGROUP_TYPES {
  SINGLE = 'single',
  SPECIAL = 'special',
  COLLECTIONS = 'collections',
}

export const SUPERSHIP_ICON = '★';
